<label *ngIf="label" [attr.for]="inputId || null" [class]="labelClass">
  {{ label | translate }}
</label>
<mat-form-field class="w-100" [class.date-picker--hidden]="hiddenTrigger">
  <input
    matInput
    readonly="readonly"
    [id]="inputId || null"
    [attr.data-testid]="testId"
    [matDatepicker]="picker"
    [min]="min"
    [max]="max"
    [formControl]="control"
    [placeholder]="placeholder ? (placeholder | translate) : ''"
  />
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
</mat-form-field>
